<template>
    <div class="selected_tag">
        <span @click="removeTag(tag)" class="remove">×</span>
        <span class="text">{{tag.name_ja}}</span>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import Util from '../assets/js/Util'

    export default {
        name: "SelectedTag",
        props: {
            tag: Object
        },
        computed: {
            ...mapState('search', ['search_conditions', 'search_text']),
        },
        methods: {
            ...mapMutations('search', ["setSearchConditions"]),
            async removeTag(tag) {
                const new_conditions = this.search_conditions.filter(t => t.id !== tag.id);
                const tags_ja = new_conditions.map(tag => tag.name_ja);
                const query_param = Util.generateQueryParam('tags[]', tags_ja, this.search_text);
                this.setSearchConditions(new_conditions);
                if ( query_param ) await this.$router.push('/?' + query_param);
                else await this.$router.push('/');
            },
        }
    }
</script>

<style scoped lang="scss">
    .selected_tag{
        display: inline-flex;
        font-size: 13px;
        color: #826E67;
        white-space: nowrap;
        .remove{
            user-select: none;
            margin-right: 0.25rem;
            cursor: pointer;
            &:hover{
                opacity: 0.8;
            }
        }
    }

    @media screen and (max-width:639px) {
        .selected_tag {
            font-size: 11px;
        }
    }
</style>
